import SecurityRule from './security.rule';

class CsrfRule extends SecurityRule {
    constructor(manager, settings = {}) {
        super(manager, settings);

        this.token = null;

        this.generateInputTag();
    }

    generateInputTag() {
        const form = this.getForm();
        let input = form.querySelector('input[name="'+form.getAttribute('name')+'[_token]"]');
        if (input === null) {
            input = document.createElement('input');
            input.setAttribute('type', 'hidden');
            input.setAttribute('name', form.getAttribute('name')+'[_token]');
            form.append(input);
        }

        this.inputElement = input;
    }

    hasToken() {
        return this.token !== null;
    }

    getNewToken(settings = {action: 'form'}) {
        return new Promise((resolve, reject) => {
            const form = this.getForm();
            if(undefined !== form.getAttribute('data-csrf-url'))
            {

                const uniqueIndex = form.getAttribute('data-uniqueIndex')
                if (uniqueIndex) {
                    var params = "?uniqueIndex=" + uniqueIndex
                } else {
                    var params = "";
                }

                let m_self = this;
                let xhr = new XMLHttpRequest();
                xhr.open('GET', form.getAttribute('data-csrf-url') + params, true);
                xhr.send(null);
                xhr.onreadystatechange = function() {
                    if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
                        let response = JSON.parse(this.response);
                        m_self.setCsrfToken(response.token);
                        resolve(response.token);
                    }
                    else if (this.readyState === XMLHttpRequest.DONE && this.status !== 200) {
                        reject();
                    }
                }
            } else {
                resolve('');
            }
        });
    }

    setCsrfToken(token) {
        this.token = token;
        this.inputElement.value = token;
        this.manager.handler.generateFormDataForPOST()
    }

    async apply(settings) {
        let token = await this.getNewToken(settings);
        return token !== null && token !== '';
    }
}

export default CsrfRule;
